import React, { useEffect, useState } from 'react';
import classes from './login.module.css';
import { useWindowSize } from "@uidotdev/usehooks";
import Header from "../components/Header/Header";
import Banner from "../Home/components/Banner";
import { Flex, Form, Input, message } from "antd";
import Footer from "../components/Footer/Footer";
import MyText from "../../components/UI/Text/MyText";
import { clrs } from "../../constants/colors";
import IntlMessage from "../../components/IntlMessage/IntlMessage";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import AuthService from "../../services/AuthService";
import { getUserByToken } from "../../store/slices/userSlice";
import { ACCESS_TOKEN } from "../../constants/auth";
import BlueButton from "../../components/UI/Buttons/BlueButton";

const Login = () => {
    const size = useWindowSize();
    const { user, isLoading } = useSelector(state => state.user);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [formLoading, setFormLoading] = useState(false);

    useEffect(() => {
        if (user) {
            navigate('/monitoring', { replace: true });
        }
    }, [user, navigate]);

    const onFinish = async (values) => {
        const loadingKey = 'loginLoading';
        setFormLoading(true);
        message.loading({ content: <IntlMessage id={'loading'} fallback={'Loading...'} />, key: loadingKey, duration: 0 });
        try {
            const res = await AuthService.login(values.username, values.password);
            if (res?.data?.access_token) {
                localStorage.setItem(ACCESS_TOKEN, res.data.access_token);
                await dispatch(getUserByToken());
                message.destroy(loadingKey);
                navigate('/monitoring', { replace: true });
            } else {
                message.destroy(loadingKey);
                message.error(<IntlMessage id={'incorrectPasswordOrUsername'} fallback={'Incorrect username or password'} />);
            }
        } catch (err) {
            message.destroy(loadingKey);
            message.error(<IntlMessage id={'incorrectPasswordOrUsername'} fallback={'Incorrect username or password'} />);
        }
        setFormLoading(false);
    };

    return (
        <div>
            <Header />
            <Flex style={{ width: "100%", position: "relative", padding: "150px 20px 20px 20px" }} align={"center"} justify={"center"}>
                <Flex gap={50} style={{ width: "100%", maxWidth: 400, position: "relative" }} vertical align={"center"} justify={"flex-start"}>
                    <MyText style={{ fontSize: "2rem", fontWeight: 800, color: clrs.textColor }}>
                        <IntlMessage id={'login.intoSystem'} />
                    </MyText>
                    <Form
                        name="login"
                        layout="vertical"
                        onFinish={onFinish}
                        style={{ width: '100%' }}
                        disabled={formLoading}
                    >
                        <Form.Item
                            name="username"
                            label={<IntlMessage id="username" fallback="Username" />}
                            rules={[{ required: true, message: <IntlMessage id="requiredField" fallback="Required field" /> }]}
                        >
                            <Input autoComplete="username" />
                        </Form.Item>
                        <Form.Item
                            name="password"
                            label={<IntlMessage id="password" fallback="Password" />}
                            rules={[{ required: true, message: <IntlMessage id="requiredField" fallback="Required field" /> }]}
                        >
                            <Input.Password autoComplete="current-password" />
                        </Form.Item>
                        <Form.Item>
                            <BlueButton htmlType="submit" loading={formLoading} block>
                                <IntlMessage id="login" fallback="Login" />
                            </BlueButton>
                        </Form.Item>
                    </Form>
                </Flex>
            </Flex>
            <Footer />
        </div>
    );
};

export default Login;